import * as actions from './linkServiceActions';

const linkServiceReducers = {
  [actions.AGENCY_LINK_STORE_DATA]: (state, { payload }) => {
    state.link = { ...state.link, ...payload };
    return state;
  },
  [actions.AGENCY_RELINK_STORE_DATA]: (state, { payload }) => {
    state.link = { ...state.link, ...payload };
    return state;
  },
  [actions.AGENCY_LINK_CLEAR_DATA]: state => {
    delete state.link;
    return state;
  },
};

export default linkServiceReducers;
